import Vue from 'vue';
import Service from './service';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_LOADED = 'UPDATE_LOADED';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_NOTARIES = 'UPDATE_COLABORATORS';
export const UPDATE_SEARCHING_NOTARY_FLAG = 'UPDATE_SEARCHING_NOTARY';
export const UPDATE_SEARCHED_NOTARY_NAME = 'UPDATE_SEARCHED_NOTARY_NAME';
export const saveNotaryAction = 'saveNotaryAction';
export const initModuleAction = 'initModuleAction';
export const searchNotaryAction = 'searchNotaryAction';
export const updateOperationNotary = 'updateOperationNotary';

export default {
  namespaced: true,
  state: {
    error: '',
    loaded: false,
    loading: false,
    types: {},
    notaries: [],
    searchedNotaryByName: null,
    searchingNotaryFlag: false,
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'types', {});
      Vue.set(state, 'loaded', false);
      Vue.set(state, 'loading', false);
      Vue.set(state, 'error', '');
      Vue.set(state, 'notaries', []);
      Vue.set(state, 'searchedNotaryByName', []);
      Vue.set(state, 'searchingNotaryFlag', false);
    },
    [UPDATE_ERROR](state, payload) {
      Vue.set(state, 'error', payload);
    },
    [UPDATE_LOADED](state, payload) {
      Vue.set(state, 'loaded', payload);
    },
    [UPDATE_LOADING](state, payload) {
      Vue.set(state, 'loading', payload);
    },
    [UPDATE_NOTARIES](state, payload) {
      state.notaries.push(payload);
    },
    [UPDATE_SEARCHING_NOTARY_FLAG](state, payload) {
      Vue.set(state, 'searchingNotaryFlag', payload);
    },
    [UPDATE_SEARCHED_NOTARY_NAME](state, payload) {
      state.searchedNotaryByName = payload;
    },
  },
  actions: {
    [initModuleAction]({ commit }) {
      commit(CLEAR_MODULE);
      return Service.getAllNotaries()
        .then(list => list.forEach(notary => commit(UPDATE_NOTARIES, notary)))
        .then(() => commit(UPDATE_LOADED, true));
    },
    [saveNotaryAction]({ commit, dispatch }, payload) {
      let promise = null;
      if ('id' in payload && payload.id !== 'dummy') {
        promise = Service.updateNotary(payload);
      } else if ('id' in payload && payload.id === 'dummy') {
        promise = Service.saveNotary(payload);
      } else {
        promise = Promise.reject('Incorrect data to save');
      }
      // return promise.then(res =>
      //   commit(UPDATE_COLABORATORS, res));
      return promise.then(() =>
        dispatch('initModuleAction'));
    },
    [searchNotaryAction]({ commit, dispatch }, payload) {
      commit(UPDATE_SEARCHED_NOTARY_NAME, []);
      commit(UPDATE_SEARCHING_NOTARY_FLAG, true);
      return dispatch('notario_model/fetchAction', {
        nombre: {
          modelName: 'title',
          operator: 'CONTAINS',
          value: payload,
          path: 'title',
        },
      }, { root: true })
        .then((lista) => {
          const { entities } = lista;
          commit(UPDATE_SEARCHING_NOTARY_FLAG, false);
          commit(UPDATE_SEARCHED_NOTARY_NAME, entities);
        })
        .catch(() => {
          commit(UPDATE_SEARCHING_NOTARY_FLAG, false);
        });
      /* return Service.searchNotaryByName(payload)
        .then((lista) => {
          commit(UPDATE_SEARCHING_NOTARY_FLAG, false);
          commit(UPDATE_SEARCHED_NOTARY_NAME, lista);
        }); */
    },
    [updateOperationNotary]({ commit, dispatch }, payload) {
      commit('UPDATE_LOADING', true);
      return Service.updateOperationNotary(payload)
        .then(() => {
          Service.updateDatesAssigments(payload)
            .then(() => commit('UPDATE_LOADING', false));
        });
    },
  },
  getters: {
    loaded: state => state.loaded,
    getLoading: state => state.loading,
    notaries: state => state.notaries,
    searchedNotaryByName: state => state.searchedNotaryByName,
    searchingNotaryFlag: state => state.searchingNotaryFlag,
  },
};



// WEBPACK FOOTER //
// ./src/features/notary/store.js